import zenGarden from "./zen-garden";
import bosqueBambu from "./bosque-bambu";

const REGISTRY = {
  [zenGarden.id]: zenGarden,
  [bosqueBambu.id]: bosqueBambu,
};

const DEFAULT_MAP_ID = zenGarden.id;

const listMaps = () =>
  Object.values(REGISTRY).map(({ id, displayName }) => ({ id, displayName }));

const getMap = (name) => {
  if (name && REGISTRY[name]) return REGISTRY[name];
  if (name) console.warn(`Mapa "${name}" no registrado, usando "${DEFAULT_MAP_ID}"`);
  return REGISTRY[DEFAULT_MAP_ID];
};

export { getMap, listMaps, DEFAULT_MAP_ID };
export default getMap;
